import { orchestrator } from 'satcheljs';
import { logFeedbackRibbonClickResponse } from '../actions/logFeedbackRibbonClickResponse';
import { sendFeedbackRibbonDatapoint } from '../services/sendFeedbackRibbonDatapoint';
import { setShowThankyouMessage } from '../mutators/setShowThankyouMessage';

export default orchestrator(logFeedbackRibbonClickResponse, async clickResponse => {
    sendFeedbackRibbonDatapoint({
        SessionId: clickResponse.SessionId,
        Feature: clickResponse.Feature,
        SubFeature: clickResponse.SubFeature,
        RibbonResponse: clickResponse.RibbonResponse,
        MetaData: clickResponse.Metadata,
    });

    if (clickResponse.clickCallback) {
        clickResponse.clickCallback();
    }

    setShowThankyouMessage({
        showThankYouMessage: true,
    });
});
